export var conversationsLayers = [{
  id: 'Conversations',
  type: 'collapsedState',
  action: 'conversationsState',
  event: true,
  contextualize: function contextualize(_ref) {
    var collapsed = _ref.collapsed;
    return {
      action: collapsed ? 'close' : 'open'
    };
  }
}];